import { createAsyncReducer, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: {
        data: [],
    },
};

function updateRetrocheckFilter(state, { filter, query }) {
    return {
        ...state,
        filter: filter,
        query: query,
    };
}

export const retrocheckFilesReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_RETROCHECK_FILES"),
    UPDATE_RETROCHECK_FILTER: updateRetrocheckFilter,
});

export default retrocheckFilesReducer;
